(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabbing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const selected = tab.dataset.tab;
    document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    document.querySelectorAll('.tab-content').forEach(tc => {
      tc.classList.remove('active');
      if (tc.dataset.tabContent === selected) {
        tc.classList.add('active');
      }
    });
  });
});

document.querySelectorAll('[data-faq]').forEach((item) => {
  const question = item.querySelector('.faq-question');
  const icon = item.querySelector('[data-icon]');
  question.addEventListener('click', () => {
    item.classList.toggle('active');
    const isOpen = item.classList.contains('active');
    // if (icon) {
    //   icon.textContent = isOpen ? '−' : '+';
    // }
  });
});

  } catch(e) { console.error(e); }
})();
})();
